const chunkMapping = {
	"31": [
		31
	],
	"83": [
		83
	],
	"104": [
		104
	],
	"115": [
		115
	],
	"216": [
		216
	],
	"746": [
		5515,
		5333,
		3152,
		1452,
		6941,
		1271,
		15,
		2653,
		3177
	],
	"863": [
		863
	],
	"1210": [
		1210
	],
	"1578": [
		1578
	],
	"1886": [
		1886
	],
	"2011": [
		2011
	],
	"2194": [
		2194
	],
	"2580": [
		2580
	],
	"2653": [
		5034
	],
	"2926": [
		2926
	],
	"3219": [
		3219
	],
	"3263": [
		3263
	],
	"3278": [
		3278
	],
	"3700": [
		3700
	],
	"3988": [
		3988
	],
	"4021": [
		4021
	],
	"4222": [
		4222
	],
	"4308": [
		4308
	],
	"4510": [
		4510
	],
	"4721": [
		4721
	],
	"4991": [
		4991
	],
	"5004": [
		5004
	],
	"5699": [
		5699
	],
	"6129": [
		6129
	],
	"6701": [
		6701
	],
	"6915": [
		6915
	],
	"6958": [
		6958
	],
	"7147": [
		7147
	],
	"7465": [
		7465
	],
	"7595": [
		7595
	],
	"8035": [
		8035
	],
	"8161": [
		8161
	],
	"8420": [
		8420
	],
	"9047": [
		9047
	],
	"9507": [
		9507
	],
	"9646": [
		9646
	],
	"9919": [
		9919
	]
};
const idToExternalAndNameMapping = {
	"15": [
		"default",
		"./store",
		2682
	],
	"31": [
		"default",
		"./Provider",
		2302
	],
	"83": [
		"default",
		"./InsurancesAdmin",
		9810
	],
	"104": [
		"default",
		"./ConfirmationForm",
		9810
	],
	"115": [
		"default",
		"./BillingAdmin",
		9810
	],
	"216": [
		"default",
		"./UsersAdmin",
		9810
	],
	"863": [
		"default",
		"./LegacyPoliciesMigrationAdmin",
		9810
	],
	"1210": [
		"default",
		"./ReportsSummaries",
		9810
	],
	"1271": [
		"default",
		"./fnxUtils",
		2682
	],
	"1452": [
		"default",
		"./LocalStorage",
		2682
	],
	"1578": [
		"default",
		"./CollectAdmin",
		9810
	],
	"1886": [
		"default",
		"./Logout",
		2682
	],
	"2011": [
		"default",
		"./PropertiesAdmin",
		9810
	],
	"2194": [
		"default",
		"./CobranzaAdmin",
		9810
	],
	"2580": [
		"default",
		"./Completed",
		9810
	],
	"2653": [
		"default",
		"./WorkflowApp",
		5521
	],
	"2926": [
		"default",
		"./CalculatePremium",
		9810
	],
	"3152": [
		"default",
		"./Loading",
		2682
	],
	"3177": [
		"default",
		"./WorkflowCreateApp",
		5521
	],
	"3219": [
		"default",
		"./CustomReportPage",
		9810
	],
	"3263": [
		"default",
		"./AccountTypeAdmin",
		9810
	],
	"3278": [
		"default",
		"./BranchesAdmin",
		9810
	],
	"3700": [
		"default",
		"./InsuranceTypeAdmin",
		9810
	],
	"3988": [
		"default",
		"./CataloguesAdmin",
		9810
	],
	"4021": [
		"default",
		"./RejectionCodesAdmin",
		9810
	],
	"4222": [
		"default",
		"./RegionAdmin",
		9810
	],
	"4308": [
		"default",
		"./ControlCenterAdmin",
		9810
	],
	"4510": [
		"default",
		"./PaymentConfirmation",
		9810
	],
	"4721": [
		"default",
		"./PassengerForm",
		9810
	],
	"4991": [
		"default",
		"./Clients",
		9810
	],
	"5004": [
		"default",
		"./AddBusiness",
		9810
	],
	"5034": [
		"default",
		"./RolAdmin",
		9810
	],
	"5333": [
		"default",
		"./FormsApp",
		8497
	],
	"5515": [
		"default",
		"./FlowApp",
		3301
	],
	"5699": [
		"default",
		"./InsurancePoliciesSummary",
		9810
	],
	"6129": [
		"default",
		"./PermissionAdmin",
		9810
	],
	"6701": [
		"default",
		"./ProjectTypeAdmin",
		9810
	],
	"6915": [
		"default",
		"./ClientRecord",
		9810
	],
	"6941": [
		"default",
		"./NotFound",
		2682
	],
	"6958": [
		"default",
		"./CustomerForms",
		9810
	],
	"7147": [
		"default",
		"./MasterApp",
		1033
	],
	"7465": [
		"default",
		"./PlanAdmin",
		9810
	],
	"7595": [
		"default",
		"./InitialInfo",
		9810
	],
	"8035": [
		"default",
		"./AuditPage",
		9810
	],
	"8161": [
		"default",
		"./ProductCreation",
		9810
	],
	"8420": [
		"default",
		"./Plan",
		9810
	],
	"9047": [
		"default",
		"./authApp",
		2302
	],
	"9507": [
		"default",
		"./PaymentSummary",
		9810
	],
	"9646": [
		"default",
		"./PlanDetails",
		9810
	],
	"9919": [
		"default",
		"./PlanCreation",
		9810
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}